import CloudSealCard from './components/vue/cloud-seal-card';
export default CloudSealCard;